//------------------------------------------------------------------------------
// Execution conditions: on document ready
//------------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
});

/**
 * Shared elements
 */
var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(navigator.userAgent);

/**
 * Global call to action banner open / close logic
 * Store the current message in 'global-call-to-action' so we know that this message was read and closed.
 */
(function () {
    //Mobile
    (function (header) {
        function clickMobile(e) {
            e.preventDefault();
            if (e.target.classList.contains('active-main')) {
                window.location.href = e.currentTarget;
            }
        }

        if (isMobile) {
            header.querySelector('#botao-conta-digital').addEventListener('click', clickMobile);
            header.querySelector('#botao-promocoes').addEventListener('click', clickMobile);
        }
    }(header));

})();

/**
 * Hide call to action on scroll
 *
 */
(function () {
    // Main menu header
    var coll = document.getElementsByClassName("collapsible-main");
    var i;

    for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function () {
            this.classList.toggle('active-main');
            var content = document.getElementsByClassName("main-menu");
            if (content[0].style.display == 'block') {
                content[0].style.display = null;
            } else {
                content[0].style.display = 'block';
            }
        });
    }

    // Conta digital e Promoções header
    var coll = document.querySelectorAll("header .collapsible-header");
    var i;

    coll.forEach(function (el, j, arr) {
        el.addEventListener("click", function () {
            var other = document.querySelectorAll(".main-menu .active-main");

            other.forEach(function (el, j, arr) {
                togleActiveElement(el, 'active-main');
            });

            togleActiveElement(this, 'active-main');
        });
    });

})();

function togleActiveElement(el, cls) {
    el.classList.toggle(cls);
}
